import React, { Component, Fragment } from 'react';
import './crearCasoTecno.css';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  TextField,
  Button,
  IconButton,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  FormHelperText,
  Select,
  InputLabel,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
  Grid,
  Box,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FaArrowLeft, FaPlus, FaCheck,  FaFileAlt  } from 'react-icons/fa';

import { clearErrors, createCasoTecno, getCasosTecnoEquipo } from '../../../redux/actions/dataactions';

export class crearCasoTecnovigilancia extends Component {
  constructor() {
    super();
    this.state = {
      // Información del paciente
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      sexo: '',
      edad: '',
      edadEn: '',
      eps: '',
      diagnosticoInicialPaciente: '',

      // Información del equipo
      nombreGenericoDispositivo: '',
      nombreComercialDispositivo: '',
      RegistroSanitario_PermisoComercializacion: '',
      activoFijo: '',
      lote: '',
      modelo: '',
      referencia: '',
      serie: '',
      marca: '',
      importadorDistribuidor: '',
      areaAccidente: '',
      ubicacion: '',
      servicio: '',
      masDeUnUso: '',

      // Descripcion del evento o incidente adverso
      fechaReporte: moment().format('YYYY-MM-DD'),
      fechaDelEvento: '',
      momentoDeteccion: '',
      clasificacionCaso: '',
      descripcionCaso: '',
      desenlaceCaso: '',
      otro: '',

      // Gestión realizada
      causaCaso: '',
      accionTomada: '',
      reporteDistibuidor: '',
      fechaReporteDistribuidor: '',
      envioDistribuidor: '',
      fechaEnvioDistribuidor: '',
      disponibleEvaluacion: '',

      // Informacion del reportante
      nombreReportante: '',
      profesion: '',
      servicioPerteneciente: '',
      direccion: '',
      telefono: '',
      correoInstitucional: '',

      errors: {},
      aprobado: {},
      open: false,
    };
  }

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI.errors) newState.errors = props.UI.errors;
    if (props.UI.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length > 0 ? newState : null;
  }

  handleOpen = () => {
    this.setState({ open: true, aprobado: {}, errors: {} });
    this.setState({
      //Información de institución
      nombreInstitucion: this.props.data.cliente.nombre,

      //Información del equipo
      nombreGenericoDispositivo: this.props.equipo.nombre,
      nombreComercialDispositivo: this.props.equipo.nombre,
      RegistroSanitario_PermisoComercializacion: this.props.equipo.registroinvima,
      activoFijo: this.props.equipo.idinventario,
      modelo: this.props.equipo.modelo,
      marca: this.props.equipo.marca,
      serie: this.props.equipo.serie,
      importadorDistribuidor: this.props.equipo.proveedor,
      servicio: this.props.equipo.servicio,
      ubicacion: this.props.equipo.ubicacion,

      // Información reportante
      nombreReportante: this.props.usuario.nombre,
      profesion: this.props.usuario.tipouser,
      direccion: this.props.usuario.direccion,
      telefono: this.props.usuario.telefono,
      correoInstitucional: this.props.usuario.email,
    });
  };

  handleClose = () => {
    this.props.clearErrors();
    this.setState({ open: false, errors: {}, aprobado: {} });
    this.setState({
      // Reset
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      sexo: '',
      edad: '',
      edadEn: '',
      eps: '',
      diagnosticoInicialPaciente: '',
      nombreGenericoDispositivo: '',
      nombreComercialDispositivo: '',
      RegistroSanitario_PermisoComercializacion: '',
      activoFijo: '',
      lote: '',
      modelo: '',
      referencia: '',
      serie: '',
      marca: '',
      importadorDistribuidor: '',
      areaAccidente: '',
      ubicacion: '',
      servicio: '',
      masDeUnUso: '',
      fechaReporte: moment().format('YYYY-MM-DD'),
      fechaDelEvento: '',
      momentoDeteccion: '',
      clasificacionCaso: '',
      descripcionCaso: '',
      desenlaceCaso: '',
      otro: '',
      causaCaso: '',
      accionTomada: '',
      reporteDistibuidor: '',
      fechaReporteDistribuidor: '',
      envioDistribuidor: '',
      fechaEnvioDistribuidor: '',
      disponibleEvaluacion: '',
      nombreReportante: '',
      profesion: '',
      servicioPerteneciente: '',
      correoInstitucional: '',
      direccion: '',
      telefono: '',
    });
    this.state.aprobado.mensaje && this.props.getCasosTecnoEquipo(this.props.equipoId);
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const newCaso = {
      cliente: this.props.clienteId,
      tipoIdentificacion: this.state.tipoIdentificacion,
      numeroIdentificacion: this.state.numeroIdentificacion,
      sexo: this.state.sexo,
      edad: this.state.edad,
      edadEn: this.state.edadEn,
      eps: this.state.eps,
      diagnosticoInicialPaciente: this.state.diagnosticoInicialPaciente,

      nombreGenericoDispositivo: this.state.nombreGenericoDispositivo,
      nombreComercialDispositivo: this.state.nombreComercialDispositivo,
      RegistroSanitario_PermisoComercializacion: this.state.RegistroSanitario_PermisoComercializacion,
      activoFijo: this.state.activoFijo,
      lote: this.state.lote,
      modelo: this.state.modelo,
      referencia: this.state.referencia,
      serie: this.state.serie,
      marca: this.state.marca,
      importadorDistribuidor: this.state.importadorDistribuidor,
      areaAccidente: this.state.servicio + '/' + this.state.ubicacion,
      masDeUnUso: this.state.masDeUnUso,

      fechaReporte: moment(this.state.fechaReporte).format('DD/MM/YYYY'),
      fechaDelEvento: moment(this.state.fechaDelEvento).format('DD/MM/YYYY'),
      momentoDeteccion: this.state.momentoDeteccion,
      clasificacionCaso: this.state.clasificacionCaso,
      descripcionCaso: this.state.descripcionCaso,
      desenlaceCaso: this.state.desenlaceCaso,
      otro: this.state.otro,

      causaCaso: this.state.causaCaso,
      accionTomada: this.state.accionTomada,
      reporteDistibuidor: this.state.reporteDistibuidor,
      fechaReporteDistribuidor: moment(this.state.fechaReporteDistribuidor).format('DD/MM/YYYY'),
      envioDistribuidor: this.state.envioDistribuidor,
      fechaEnvioDistribuidor: moment(this.state.fechaEnvioDistribuidor).format('DD/MM/YYYY'),
      disponibleEvaluacion: this.state.disponibleEvaluacion,

      nombreReportante: this.state.nombreReportante,
      profesion: this.state.profesion,
      direccion: this.state.direccion,
      telefono: this.state.telefono,
      servicioPerteneciente: this.state.servicioPerteneciente,
      correoInstitucional: this.state.correoInstitucional,
      estadoReporte: 'A',
    };

    this.props.usuario.tipouser === 'Asistencial'
      ? this.props.createCasoTecno(newCaso, this.props.usuario.idprestador, this.props.equipoId)
      : this.props.createCasoTecno(newCaso, this.props.clienteId, this.props.equipoId);
  };

  render() {
    const {
      UI: { loading },
    } = this.props;
    const { errors } = this.state;

    return (
      <div>
        <Fragment>
          {/* Botón abrir (reemplaza MyButton) */}
          <Tooltip title="Registrar caso de tecnovigilancia">
            <IconButton onClick={this.handleOpen} size="small">
              <FaFileAlt color="#03178C" className="icon-crearcliente" />
            </IconButton>
          </Tooltip>

          <Dialog open={this.state.open} onClose={this.handleClose} fullWidth maxWidth="sm">
            {this.state.aprobado.mensaje ? (
              <Box className="div-aprobado" sx={{ p: 3 }}>
                <div className="div-icono-aprobado">
                  <FaCheck color="#ffffff" className="icono-aprobado" />
                </div>
                <h2 className="text-aprobado">¡Se ha registrado exitosamente el caso!</h2>

                {this.state.clasificacionCaso === 'Evento adverso serio' ||
                this.state.clasificacionCaso === 'Incidente adverso serio' ? (
                  <div className="mensaje_casos">
                    <p>
                      Este caso está registrado como evento/incidente adverso serio. <br />
                      Recuerde que tiene menos de <strong>72 horas desde la ocurrencia del caso</strong> para completar y subir el{' '}
                      <a
                        href="https://www.saludcapital.gov.co/SectorBelleza/Galeria%20de%20Descargas/Acreditaci%C3%B3n/Est%C3%A1ndares%20acreditaci%C3%B3n%20est%C3%A9tica/REPORTE%20EVENTOS%20SERIOS%20FOREIA001.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        formato FOREIA001
                      </a>{' '}
                      a la plataforma del INVIMA.
                    </p>
                  </div>
                ) : (
                  <div className="mensaje_casos">
                    <p>
                      Este caso está registrado como evento/incidente adverso no serio. <br />
                      Recuerde que este tipo de casos <strong>deben ser registrados en el</strong>{' '}
                      <a href="https://ids.gov.co/2021/Medicamentos/RETEIM-002-reporte_masivo_trimestral.xlsx" target="_blank" rel="noopener noreferrer">
                        formato RETEIM-002
                      </a>{' '}
                      <strong>por el ingeniero encargado</strong> y cargarlo en el trimestre correspondiente a la plataforma del INVIMA.
                    </p>
                  </div>
                )}
              </Box>
            ) : (
              <div>
                <DialogTitle>
                <Typography sx={{ fontSize: '20px', fontWeight: 600, color: '#0468BF', textAlign: 'center' }}>
                  Crear Caso de Tecnovigilancia
                </Typography>
              </DialogTitle>
                <DialogContent dividers>
                  <form>
                    {/* ====================== ACCORDION: Información del paciente ====================== */}
                    <Accordion>
                      <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                     <Typography sx={{
                                         color: '#0468BF',
                                         fontSize: '18px',
                                         fontWeight: 400,
                                         ml: 1,
                                       }}>
                                         Información del Paciente (Opcional)
                                       </Typography>
                    </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          {/* Tipo doc / Número */}
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" error={Boolean(errors.tipoIdentificacion)}>
                              <InputLabel id="tipoIdentificacion-label">Tipo de documento</InputLabel>
                              <Select
                                labelId="tipoIdentificacion-label"
                                label="Tipo de documento"
                                required
                                name="tipoIdentificacion"
                                id="tipoIdentificacion"
                                value={this.state.tipoIdentificacion}
                                onChange={this.handleChange}
                              >
                                <MenuItem value=""><em></em></MenuItem>
                                <MenuItem value="CC">Cédula de Ciudadanía</MenuItem>
                                <MenuItem value="TI">Tarjeta de Identidad</MenuItem>
                                <MenuItem value="RC">Registro Civil</MenuItem>
                                <MenuItem value="PS">Pasaporte</MenuItem>
                                <MenuItem value="CE">Cédula de Extranjería</MenuItem>
                                <MenuItem value="MI">Menor sin Identificación</MenuItem>
                                <MenuItem value="AI">Adulto sin Identificación</MenuItem>
                                <MenuItem value="HC">Historia Clinica</MenuItem>
                              </Select>
                              <FormHelperText>{errors.tipoIdentificacion}</FormHelperText>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="number"
                              name="numeroIdentificacion"
                              id="numeroIdentificacion"
                              label="Número de identificación"
                              value={this.state.numeroIdentificacion}
                              onChange={this.handleChange}
                              helperText={errors.numeroIdentificacion}
                              error={Boolean(errors.numeroIdentificacion)}
                              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                            />
                          </Grid>

                          {/* Sexo / Edad / Edad en */}
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" error={Boolean(errors.sexo)}>
                              <InputLabel id="sexo-label">Sexo</InputLabel>
                              <Select
                                labelId="sexo-label"
                                label="Sexo"
                                required
                                name="sexo"
                                id="sexo"
                                value={this.state.sexo}
                                onChange={this.handleChange}
                              >
                                <MenuItem value=""><em></em></MenuItem>
                                <MenuItem value="Femenino">Femenino</MenuItem>
                                <MenuItem value="Masculino">Masculino</MenuItem>
                                <MenuItem value="Sin dato">Sin dato</MenuItem>
                              </Select>
                              <FormHelperText>{errors.sexo}</FormHelperText>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="number"
                              name="edad"
                              id="edad"
                              label="Edad"
                              value={this.state.edad}
                              onChange={this.handleChange}
                              helperText={errors.edad}
                              error={Boolean(errors.edad)}
                              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*', min: 0 }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" error={Boolean(errors.edadEn)}>
                              <InputLabel id="edadEn-label">Edad de la persona en</InputLabel>
                              <Select
                                labelId="edadEn-label"
                                label="Edad de la persona en"
                                required
                                name="edadEn"
                                id="edadEn"
                                value={this.state.edadEn}
                                onChange={this.handleChange}
                              >
                                <MenuItem value=""><em></em></MenuItem>
                                <MenuItem value="días">Días</MenuItem>
                                <MenuItem value="semanas">Semanas</MenuItem>
                                <MenuItem value="meses">Meses</MenuItem>
                                <MenuItem value="años">Años</MenuItem>
                              </Select>
                              <FormHelperText>{errors.edadEn}</FormHelperText>
                            </FormControl>
                          </Grid>

                          {/* EPS / Diagnóstico */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="eps"
                              id="eps"
                              label="EPS del paciente"
                              value={this.state.eps}
                              onChange={this.handleChange}
                              helperText={errors.eps}
                              error={Boolean(errors.eps)}
                              autoComplete="organization"
                            />
                          </Grid>
                          <Grid item xs={12}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="diagnosticoInicialPaciente"
                              id="diagnosticoInicialPaciente"
                              label="Diagnóstico inicial del paciente"
                              value={this.state.diagnosticoInicialPaciente}
                              onChange={this.handleChange}
                              helperText={errors.diagnosticoInicialPaciente}
                              error={Boolean(errors.diagnosticoInicialPaciente)}
                              multiline
                              minRows={2}
                            />
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    {/* ====================== ACCORDION: Información del equipo ====================== */}
                    <Accordion>
                      <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >

                      <Typography sx={{
                                          color: '#0468BF',
                                          fontSize: '18px',
                                          fontWeight: 400,
                                          ml: 1,
                                        }}>
                                          Información del Equipo
                                        </Typography>
                      
                    </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          {/* Generico / Comercial */}
                          <Grid item xs={12} sm={12}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="nombreGenericoDispositivo"
                              id="nombreGenericoDispositivo"
                              label="Nombre genérico del equipo"
                              value={this.state.nombreGenericoDispositivo}
                              onChange={this.handleChange}
                              helperText={errors.nombreGenericoDispositivo}
                              error={Boolean(errors.nombreGenericoDispositivo)}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12} sm={12}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="nombreComercialDispositivo"
                              id="nombreComercialDispositivo"
                              label="Nombre comercial del equipo"
                              value={this.state.nombreComercialDispositivo}
                              onChange={this.handleChange}
                              helperText={errors.nombreComercialDispositivo}
                              error={Boolean(errors.nombreComercialDispositivo)}
                            />
                          </Grid>

                          {/* Registro / Activo fijo */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="RegistroSanitario_PermisoComercializacion"
                              id="RegistroSanitario_PermisoComercializacion"
                              label="Registro Invima"
                              value={this.state.RegistroSanitario_PermisoComercializacion}
                              onChange={this.handleChange}
                              helperText={errors.RegistroSanitario_PermisoComercializacion}
                              error={Boolean(errors.RegistroSanitario_PermisoComercializacion)}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="activoFijo"
                              id="activoFijo"
                              label="Activo fijo del equipo"
                              value={this.state.activoFijo}
                              onChange={this.handleChange}
                              helperText={errors.activoFijo}
                              error={Boolean(errors.activoFijo)}
                              disabled
                            />
                          </Grid>

                          {/* Lote / Modelo */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              type="text"
                              name="lote"
                              id="lote"
                              label="Lote"
                              value={this.state.lote}
                              onChange={this.handleChange}
                              helperText={errors.lote}
                              error={Boolean(errors.lote)}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="modelo"
                              id="modelo"
                              label="Modelo"
                              value={this.state.modelo}
                              onChange={this.handleChange}
                              helperText={errors.modelo}
                              error={Boolean(errors.modelo)}
                              disabled
                            />
                          </Grid>

                          {/* Referencia / Serie */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              type="text"
                              name="referencia"
                              id="referencia"
                              label="Referencia"
                              value={this.state.referencia}
                              onChange={this.handleChange}
                              helperText={errors.referencia}
                              error={Boolean(errors.referencia)}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="serie"
                              id="serie"
                              label="Serie"
                              value={this.state.serie}
                              onChange={this.handleChange}
                              helperText={errors.serie}
                              error={Boolean(errors.serie)}
                              disabled
                            />
                          </Grid>

                          {/* Marca / Importador */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="marca"
                              id="marca"
                              label="Razón social del fabricante"
                              value={this.state.marca}
                              onChange={this.handleChange}
                              helperText={errors.marca}
                              error={Boolean(errors.marca)}
                              disabled
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="importadorDistribuidor"
                              id="importadorDistribuidor"
                              label="Importador/distribuidor"
                              value={this.state.importadorDistribuidor}
                              onChange={this.handleChange}
                              helperText={errors.importadorDistribuidor}
                              error={Boolean(errors.importadorDistribuidor)}
                              disabled
                            />
                          </Grid>

                          {/* Servicio / Ubicación */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="servicio"
                              id="servicio"
                              label="Servicio"
                              value={this.state.servicio}
                              onChange={this.handleChange}
                              helperText={errors.servicio}
                              error={Boolean(errors.servicio)}
                              autoComplete="section-dept"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="ubicacion"
                              id="ubicacion"
                              label="Ubicación"
                              value={this.state.ubicacion}
                              onChange={this.handleChange}
                              helperText={errors.ubicacion}
                              error={Boolean(errors.ubicacion)}
                              autoComplete="section-room"
                            />
                          </Grid>

                          {/* ¿Más de un uso? */}
                          <Grid item xs={12} sm={12}>
                            <FormControl fullWidth size="small" error={Boolean(errors.masDeUnUso)}>
                              <InputLabel id="masDeUnUso-label">¿Se ha usado más de una vez?</InputLabel>
                              <Select
                                labelId="masDeUnUso-label"
                                label="¿Se ha usado más de una vez?"
                                required
                                name="masDeUnUso"
                                id="masDeUnUso"
                                value={this.state.masDeUnUso}
                                onChange={this.handleChange}
                              >
                                <MenuItem value=""><em></em></MenuItem>
                                <MenuItem value="Si">Sí</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                              </Select>
                              <FormHelperText>{errors.masDeUnUso}</FormHelperText>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    {/* ====================== ACCORDION: Clasificación del caso ====================== */}
                    <Accordion>
                       <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{
                                          color: '#0468BF',
                                          fontSize: '18px',
                                          fontWeight: 400,
                                          ml: 1,
                                        }}>
                                          Clasificación del Caso
                                        </Typography>
                                   </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          {/* Fechas */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="date"
                              name="fechaDelEvento"
                              id="fechaDelEvento"
                              label="Fecha de ocurrencia del evento"
                              value={this.state.fechaDelEvento}
                              onChange={this.handleChange}
                              helperText={errors.fechaDelEvento}
                              error={Boolean(errors.fechaDelEvento)}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ max: moment().format('YYYY-MM-DD') }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="date"
                              name="fechaReporte"
                              id="fechaReporte"
                              label="Fecha del reporte"
                              value={this.state.fechaReporte}
                              onChange={this.handleChange}
                              helperText={errors.fechaReporte}
                              error={Boolean(errors.fechaReporte)}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ max: moment().format('YYYY-MM-DD') }}
                              disabled
                            />
                          </Grid>

                          {/* Detección / Clasificación */}
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" error={Boolean(errors.momentoDeteccion)}>
                              <InputLabel id="momentoDeteccion-label">Detección del caso</InputLabel>
                              <Select
                                labelId="momentoDeteccion-label"
                                label="Detección del caso"
                                required
                                name="momentoDeteccion"
                                id="momentoDeteccion"
                                value={this.state.momentoDeteccion}
                                onChange={this.handleChange}
                              >
                                <MenuItem value=""><em></em></MenuItem>
                                <MenuItem value="Antes del uso del DM">Antes de utilizarlo</MenuItem>
                                <MenuItem value="Durante el uso del DM">Durante el uso</MenuItem>
                                <MenuItem value="Después del uso del DM">Después de utilizarlo</MenuItem>
                              </Select>
                              <FormHelperText>{errors.momentoDeteccion}</FormHelperText>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" error={Boolean(errors.clasificacionCaso)}>
                              <InputLabel id="clasificacionCaso-label">Clasificación</InputLabel>
                              <Select
                                labelId="clasificacionCaso-label"
                                label="Clasificación"
                                required
                                name="clasificacionCaso"
                                id="clasificacionCaso"
                                value={this.state.clasificacionCaso}
                                onChange={this.handleChange}
                              >
                                <MenuItem value=""><em></em></MenuItem>
                                <MenuItem value="Evento adverso serio">Evento adverso serio</MenuItem>
                                <MenuItem value="Evento adverso no serio">Evento adverso no serio</MenuItem>
                                <MenuItem value="Incidente adverso serio">Incidente adverso serio</MenuItem>
                                <MenuItem value="Incidente adverso no serio">Incidente adverso no serio</MenuItem>
                              </Select>
                              <FormHelperText>{errors.clasificacionCaso}</FormHelperText>
                            </FormControl>
                          </Grid>

                          {/* Desenlace / Otro */}
                          <Grid item xs={12} sm={12}>
                            <FormControl fullWidth size="small" error={Boolean(errors.desenlaceCaso)}>
                              <InputLabel id="desenlaceCaso-label">Desenlace del caso</InputLabel>
                              <Select
                                labelId="desenlaceCaso-label"
                                label="Desenlace del caso"
                                required
                                name="desenlaceCaso"
                                id="desenlaceCaso"
                                value={this.state.desenlaceCaso}
                                onChange={this.handleChange}
                              >
                                <MenuItem value=""><em></em></MenuItem>
                                <MenuItem value="Murio">Murió</MenuItem>
                                <MenuItem value="Daño de una función o estructura corporal">Daño de una función o estructura corporal</MenuItem>
                                <MenuItem value="Enfermedad o daño que amenace la vida">Enfermedad o daño que amenace la vida</MenuItem>
                                <MenuItem value="Requiere intervención médica o quirúrgica, para prevenir un daño permanente de una estructura o función corporal">
                                  Requiere intervención médica o quirúrgica, para prevenir un daño permanente de una estructura o función corporal
                                </MenuItem>
                                <MenuItem value="Hospitalización inicial o prolongada">Hospitalización inicial o prolongada</MenuItem>
                                <MenuItem value="No hubo daño">No hubo daño</MenuItem>
                                <MenuItem value="Otro">Otro</MenuItem>
                              </Select>
                              <FormHelperText>{errors.desenlaceCaso}</FormHelperText>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={12}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="otro"
                              id="otro"
                              label="¿Otro? Especifique"
                              value={this.state.otro}
                              onChange={this.handleChange}
                              helperText={errors.otro}
                              error={Boolean(errors.otro)}
                              disabled={this.state.desenlaceCaso === 'Otro' ? false : true}
                            />
                          </Grid>

                          {/* Descripción */}
                          <Grid item xs={12}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="descripcionCaso"
                              id="descripcionCaso"
                              label="Descripción del caso"
                              value={this.state.descripcionCaso}
                              onChange={this.handleChange}
                              helperText={errors.descripcionCaso}
                              error={Boolean(errors.descripcionCaso)}
                              multiline
                              minRows={3}
                            />
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    {/* ====================== ACCORDION: Gestión Realizada ====================== */}
                    <Accordion>
                      <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{
                                          color: '#0468BF',
                                          fontSize: '18px',
                                          fontWeight: 400,
                                          ml: 1,
                                        }}>
                                          Gestión Realizada
                                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          {/* Causa / Acciones */}
                          <Grid item xs={12} sm={12}>
                            <FormControl fullWidth size="small" error={Boolean(errors.causaCaso)}>
                              <InputLabel id="causaCaso-label">Causa probable del caso</InputLabel>
                              <Select
                                labelId="causaCaso-label"
                                label="Causa probable del caso"
                                required
                                name="causaCaso"
                                id="causaCaso"
                                value={this.state.causaCaso}
                                onChange={this.handleChange}
                              >
                                <MenuItem value=""><em></em></MenuItem>
                                <MenuItem value="Uso anormal">Uso anormal</MenuItem>
                                <MenuItem value="Respuesta fisiológica anormal o inesperada">Respuesta fisiológica anormal o inesperada</MenuItem>
                                <MenuItem value="Falla en la alarma">Falla en la alarma</MenuItem>
                                <MenuItem value="Uso de material biológico">Uso de material biológico</MenuItem>
                                <MenuItem value="Calibración">Calibración</MenuItem>
                                <MenuItem value="Hardware del computador">Hardware del computador</MenuItem>
                                <MenuItem value="Contaminación durante la producción">Contaminación durante la producción</MenuItem>
                                <MenuItem value="Contaminación post-producción">Contaminación post-producción</MenuItem>
                                <MenuItem value="Diseño">Diseño</MenuItem>
                                <MenuItem value="Desconexión">Desconexión</MenuItem>
                                <MenuItem value="Componente eléctrico">Componente eléctrico</MenuItem>
                                <MenuItem value="Circuito eléctrico">Circuito eléctrico</MenuItem>
                                <MenuItem value="Contacto eléctrico">Contacto eléctrico</MenuItem>
                                <MenuItem value="Interferencia Electromagnética IEM">Interferencia Electromagnética IEM</MenuItem>
                                <MenuItem value="Fecha de expiración">Fecha de expiración</MenuItem>
                                <MenuItem value="Falso Negativo">Falso Negativo</MenuItem>
                                <MenuItem value="Falso positivo">Falso positivo</MenuItem>
                                <MenuItem value="Resultado falso de la prueba">Resultado falso de la prueba</MenuItem>
                                <MenuItem value="Falla en el dispositivo implantable">Falla en el dispositivo implantable</MenuItem>
                                <MenuItem value="Ambiente Inapropiado">Ambiente Inapropiado</MenuItem>
                                <MenuItem value="Incompatibilidad">Incompatibilidad</MenuItem>
                                <MenuItem value="Instrucciones para uso y etiquetado">Instrucciones para uso y etiquetado</MenuItem>
                                <MenuItem value="Escape/ sellado">Escape/ sellado</MenuItem>
                                <MenuItem value="Mantenimiento">Mantenimiento</MenuItem>
                                <MenuItem value="Fabricación">Fabricación</MenuItem>
                                <MenuItem value="Material">Material</MenuItem>
                                <MenuItem value="Componentes Mecánicos">Componentes Mecánicos</MenuItem>
                                <MenuItem value="Condiciones no higiénicas">Condiciones no higiénicas</MenuItem>
                                <MenuItem value="No relacionado con el dispositivo">No relacionado con el dispositivo</MenuItem>
                                <MenuItem value="Otros">Otros</MenuItem>
                                <MenuItem value="Empaque">Empaque</MenuItem>
                                <MenuItem value="Anatomía/Fisiología del paciente">Anatomía/Fisiología del paciente</MenuItem>
                                <MenuItem value="Condición del paciente">Condición del paciente</MenuItem>
                                <MenuItem value="Fuente de energía">Fuente de energía</MenuItem>
                                <MenuItem value="Medidas de protección">Medidas de protección</MenuItem>
                                <MenuItem value="Aseguramiento  de la calidad en la institución para la atención en salud">Aseguramiento  de la calidad en la institución para la atención en salud</MenuItem>
                                <MenuItem value="Radiación">Radiación</MenuItem>
                                <MenuItem value="Software">Software</MenuItem>
                                <MenuItem value="Esterilización/desinfección/ limpieza">Esterilización/desinfección/ limpieza</MenuItem>
                                <MenuItem value="Condiciones de almacenamiento">Condiciones de almacenamiento</MenuItem>
                                <MenuItem value="Alteración/falsificación/ sabotaje">Alteración/falsificación/ sabotaje</MenuItem>
                                <MenuItem value="Entrenamiento">Entrenamiento</MenuItem>
                                <MenuItem value="Transporte y entrega">Transporte y entrega</MenuItem>
                                <MenuItem value="Sin identificar">Sin identificar</MenuItem>
                                <MenuItem value="Capacidad de Uso">Capacidad de Uso</MenuItem>
                                <MenuItem value="Error de Uso">Error de Uso</MenuItem>
                                <MenuItem value="Desgaste">Desgaste</MenuItem>
                              </Select>
                              <FormHelperText>{errors.causaCaso}</FormHelperText>
                            </FormControl>
                          </Grid>

                          <Grid item xs={12} sm={12}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="accionTomada"
                              id="accionTomada"
                              label="Acciones correctivas y preventivas iniciadas"
                              value={this.state.accionTomada}
                              onChange={this.handleChange}
                              helperText={errors.accionTomada}
                              error={Boolean(errors.accionTomada)}
                            />
                          </Grid>

                          {/* ¿Reportó distribuidor? / Fecha reporte */}
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" error={Boolean(errors.reporteDistibuidor)}>
                              <InputLabel id="reporteDistibuidor-label">¿Reportó al distribuidor?</InputLabel>
                              <Select
                                labelId="reporteDistibuidor-label"
                                label="¿Reportó al distribuidor?"
                                required
                                name="reporteDistibuidor"
                                id="reporteDistibuidor"
                                value={this.state.reporteDistibuidor}
                                onChange={this.handleChange}
                              >
                                <MenuItem value=""><em></em></MenuItem>
                                <MenuItem value="Si">Sí</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                              </Select>
                              <FormHelperText>{errors.reporteDistibuidor}</FormHelperText>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              type="date"
                              name="fechaReporteDistribuidor"
                              id="fechaReporteDistribuidor"
                              label="Fecha de reporte al distribuidor"
                              value={this.state.fechaReporteDistribuidor}
                              onChange={this.handleChange}
                              helperText={errors.fechaReporteDistribuidor}
                              error={Boolean(errors.fechaReporteDistribuidor)}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ max: moment().format('YYYY-MM-DD') }}
                              disabled={this.state.reporteDistibuidor === 'Si' ? false : true}
                            />
                          </Grid>

                          {/* ¿Se envió? / Fecha envío */}
                          <Grid item xs={12} sm={6}>
                            <FormControl fullWidth size="small" error={Boolean(errors.envioDistribuidor)}>
                              <InputLabel id="envioDistribuidor-label">¿Se envió al distribuidor?</InputLabel>
                              <Select
                                labelId="envioDistribuidor-label"
                                label="¿Se envió al distribuidor?"
                                required
                                name="envioDistribuidor"
                                id="envioDistribuidor"
                                value={this.state.envioDistribuidor}
                                onChange={this.handleChange}
                              >
                                <MenuItem value=""><em></em></MenuItem>
                                <MenuItem value="Si">Sí</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                              </Select>
                              <FormHelperText>{errors.envioDistribuidor}</FormHelperText>
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              type="date"
                              name="fechaEnvioDistribuidor"
                              id="fechaEnvioDistribuidor"
                              label="Fecha de envio al distribuidor"
                              value={this.state.fechaEnvioDistribuidor}
                              onChange={this.handleChange}
                              helperText={errors.fechaEnvioDistribuidor}
                              error={Boolean(errors.fechaEnvioDistribuidor)}
                              InputLabelProps={{ shrink: true }}
                              inputProps={{ max: moment().format('YYYY-MM-DD') }}
                              disabled={this.state.envioDistribuidor === 'Si' ? false : true}
                            />
                          </Grid>

                          {/* ¿Disponible para evaluación? */}
                          <Grid item xs={12} sm={12}>
                            <FormControl fullWidth size="small" error={Boolean(errors.disponibleEvaluacion)}>
                              <InputLabel id="disponibleEvaluacion-label">¿Disponible para evaluación?</InputLabel>
                              <Select
                                labelId="disponibleEvaluacion-label"
                                label="¿Disponible para evaluación?"
                                required
                                name="disponibleEvaluacion"
                                id="disponibleEvaluacion"
                                value={this.state.disponibleEvaluacion}
                                onChange={this.handleChange}
                              >
                                <MenuItem value=""><em></em></MenuItem>
                                <MenuItem value="Si">Sí</MenuItem>
                                <MenuItem value="No">No</MenuItem>
                              </Select>
                              <FormHelperText>{errors.disponibleEvaluacion}</FormHelperText>
                            </FormControl>
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    {/* ====================== ACCORDION: Información del reportante ====================== */}
                    <Accordion>
                      <AccordionSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls="panel1a-content"
                      id="panel1a-header"
                    >
                      <Typography sx={{
                                          color: '#0468BF',
                                          fontSize: '18px',
                                          fontWeight: 400,
                                          ml: 1,
                                        }}>
                                          Información del Reportante
                                        </Typography>
                    </AccordionSummary>
                      <AccordionDetails>
                        <Grid container spacing={2}>
                          {/* Nombre completo */}
                          <Grid item xs={12}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="nombreReportante"
                              id="nombreReportante"
                              label="Nombres y apellidos completos del reportante"
                              value={this.state.nombreReportante}
                              onChange={this.handleChange}
                              helperText={errors.nombreReportante}
                              error={Boolean(errors.nombreReportante)}
                              autoComplete="name"
                            />
                          </Grid>

                          {/* Profesión / Área */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="profesion"
                              id="profesion"
                              label="Profesión"
                              value={this.state.profesion}
                              onChange={this.handleChange}
                              helperText={errors.profesion}
                              error={Boolean(errors.profesion)}
                              autoComplete="organization-title"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              required
                              type="text"
                              name="servicioPerteneciente"
                              id="servicioPerteneciente"
                              label="Área o servicio al que pertenece"
                              value={this.state.servicioPerteneciente}
                              onChange={this.handleChange}
                              helperText={errors.servicioPerteneciente}
                              error={Boolean(errors.servicioPerteneciente)}
                              autoComplete="section-dept"
                            />
                          </Grid>

                          {/* Dirección / Teléfono */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              type="text"
                              name="direccion"
                              id="direccion"
                              label="Dirección"
                              value={this.state.direccion}
                              onChange={this.handleChange}
                              helperText={errors.direccion}
                              error={Boolean(errors.direccion)}
                              autoComplete="street-address"
                            />
                          </Grid>
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              type="text"
                              name="telefono"
                              id="telefono"
                              label="Teléfono"
                              value={this.state.telefono}
                              onChange={this.handleChange}
                              helperText={errors.telefono}
                              error={Boolean(errors.telefono)}
                              inputProps={{ inputMode: 'tel' }}
                              autoComplete="tel"
                            />
                          </Grid>

                          {/* Correo */}
                          <Grid item xs={12} sm={6}>
                            <TextField
                              size="small"
                              fullWidth
                              type="text"
                              name="correoInstitucional"
                              id="correoInstitucional"
                              label="Correo institucional"
                              value={this.state.correoInstitucional}
                              onChange={this.handleChange}
                              helperText={errors.correoInstitucional}
                              error={Boolean(errors.correoInstitucional)}
                              autoComplete="email"
                            />
                          </Grid>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>

                    {Object.keys(errors).length > 0 && (
                      <Box sx={{ mt: 2 }}>
                        <p>Por favor, diligencie todos los campos mínimamente obligatorios para crear un caso</p>
                      </Box>
                    )}
                  </form>
                </DialogContent>
              </div>
            )}

            <DialogActions>
              {/* Cerrar */}
              <Tooltip title="Cerrar">
                               <IconButton onClick={this.handleClose} size="small">
                                 <FaArrowLeft color="#e2e2e2" />
                               </IconButton>
                             </Tooltip>

              {/* Registro / Continuar */}
              {loading ? (
                <CircularProgress size={24} className="login-progress" />
              ) : this.state.aprobado.mensaje ? (
                <Tooltip title="Continuar">
                                   <IconButton onClick={this.handleClose} size="small">
                                     <FaCheck color="#03178C" />
                                   </IconButton>
                                 </Tooltip>
              ) : (
                 <Tooltip title="Crear Registro">
                                    <IconButton onClick={this.handleSubmit} size="small">
                                      <FaPlus color="#03178C" />
                                    </IconButton>
                                  </Tooltip>
              )}
            </DialogActions>
          </Dialog>
        </Fragment>
      </div>
    );
  }
}

crearCasoTecnovigilancia.propTypes = {
  clearErrors: PropTypes.func.isRequired,
  getCasosTecnoEquipo: PropTypes.func.isRequired,
  createCasoTecno: PropTypes.func.isRequired,
  UI: PropTypes.object.isRequired,
};

const mapActionsToProps = {
  clearErrors,
  createCasoTecno,
  getCasosTecnoEquipo,
};

const mapStateToProps = (state) => ({
  UI: state.UI,
  equipo: state.data.equipo.credentials,
  data: state.data,
  usuario: state.user.credentials,
});

export default connect(mapStateToProps, mapActionsToProps)(crearCasoTecnovigilancia);
